import { type ReactElement } from 'react';
import { type DistributiveOmit } from '@direct-frontend/stdlib';
import { type BaseRowData } from '@adv-frontend/data-provider';
import { LegacyGridStub, type LegacyGridStubProps } from '@adv-frontend/grid';
import { GridLayout, type GridLayoutProps } from '../../../layouts';

export type GridLayoutStubProps<RowData extends BaseRowData> = DistributiveOmit<
    LegacyGridStubProps<RowData>,
    'className'
> & {
    gridLayoutProps?: Pick<GridLayoutProps, 'data-testid' | 'containerClassName'>;
};

/**
 * Скелетон грида в обёртке {@link GridLayout}
 *
 * @typeParam RowData Тип строки грида.
 * @kind helper
 * @returns Разметку скелетона грида: {@link LegacyGridStub} внутри {@link GridLayout}.
 */
export function GridLayoutStub<RowData extends BaseRowData>({
    gridLayoutProps,
    cellSize = 'm',
    ...stubProps
}: GridLayoutStubProps<RowData>): ReactElement {
    return (
        <GridLayout {...gridLayoutProps}>
            {({ className }) => <LegacyGridStub<RowData> className={className} cellSize={cellSize} {...stubProps} />}
        </GridLayout>
    );
}
